/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { ClipboardList, Activity, Calendar, PhoneCall } from 'lucide-react';

export const urgencyMeta = {
  low:      { label: 'Bassa',      color: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20' },
  medium:   { label: 'Media',      color: 'bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20' },
  high:     { label: 'Alta',       color: 'bg-orange-500/10 text-orange-700 dark:text-orange-300 border-orange-500/20' },
  critical: { label: 'Critica',    color: 'bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20' },
};

export const likelihoodMeta = {
  low:    'bg-muted text-muted-foreground',
  medium: 'bg-amber-500/10 text-amber-700 dark:text-amber-300',
  high:   'bg-red-500/10 text-red-700 dark:text-red-300',
};

export const actionMeta = {
  self_care:            { label: 'Auto-cura', icon: ClipboardList, cls: 'text-emerald-600' },
  see_doctor_soon:      { label: 'Prenota visita', icon: Calendar, cls: 'text-amber-600' },
  urgent_care:          { label: 'Assistenza urgente', icon: Activity, cls: 'text-orange-600' },
  emergency_call_118:   { label: 'Chiama il 118', icon: PhoneCall, cls: 'text-red-600' },
};
